/* 七牛配置相关的枚举参数 */

// 七牛文件夹名称
// 部分bucket不支持 '?imageView2/2/w/100/h/100/q/100/format/jpg'，对不不支持的请使用下面 UrlSuffix 提供的后缀（一般使用水印或缩略图后缀）
export const Bucket = {
  Default: 'linhuiba-crm' // 默认使用的bucket
};

export const Domain = {
  Default: 'https://crm.linhuiba.com'
};

// // 地址后缀相关
// // 除了原图，其他后缀的图片都是按照一定比例截取的，这个在七牛平台进行配置了
// export const UrlSuffix = {
//   Ori: '-middlestage_original', // 原图
//   // Wk: '-linhuiba_watermark', // 水印
//   // Half: '-location_half', // 中间半张图
//   Thn: '-middlestage_thn' // 缩略图
// }

// 七牛文件夹映射的上传域名 https://developer.qiniu.com/kodo/manual/1671/region-endpoint
export const bucketMappingActionUrl = '//upload.qiniup.com';

